/**
 * The subscription checkout's return trip (ToU 2.2 §8).
 *
 * **WHAT LEFT THIS FILE.** The wallet, the packs, the ledger, auto-reload and
 * the spend limit went with the credit product (ruling R-0916-1), and the paid
 * reset that was the one purchase outside a subscription is deleted (ruling
 * R-0923-3 (1)).
 *
 * `checkoutOutcome` / `clearCheckoutQuery` are the subscription checkout's
 * return trip through Stripe's own origin, and `lib/draft.ts`'s round-trip
 * machinery depends on them.
 */
/** What the browser is carrying back from a subscription checkout, if anything. */
export type CheckoutOutcome = "paid" | "unpaid" | null;

export function checkoutOutcome(
  search: string = typeof window === "undefined" ? "" : window.location.search,
): CheckoutOutcome {
  const paid = new URLSearchParams(search).get("paid");
  if (paid === "1") return "paid";
  if (paid === "0") return "unpaid";
  return null;
}

/** The flag is a one-shot: a reload must not re-announce a purchase. */
export function clearCheckoutQuery(): void {
  if (typeof window === "undefined" || !window.history?.replaceState) return;
  const url = new URL(window.location.href);
  if (!url.searchParams.has("paid")) return;
  url.searchParams.delete("paid");
  window.history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
}
